import { isAdminRole } from '@lombok/shared';
import { useAuth } from './AuthContext';

/**
 * True for admin / super_admin. Catalog, account and promotion changes are admin-only on the
 * API (it answers 403 to everyone else, finance included), so screens hide those buttons from
 * the other roles. A UX gate only: the backend stays the authority.
 */
export function useIsAdmin(): boolean {
  const { session } = useAuth();
  return session ? isAdminRole(session.user.role) : false;
}
